function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "0,136.467 1.008,131.877 9.047,125.699 7.466,122.117 11.776,121.104 16.931,106.748 10.051,98.131  6.744,96.694 5.313,83.92 2.592,79.611 4.744,65.257 8.474,63.535 11.201,66.403 12.779,60.946 17.66,60.946 25.406,64.966  29.863,62.385 26.706,56.353 31.871,48.174 37.333,48.174 36.612,52.767 41.637,60.946 42.785,58.794 44.074,60.661 49.82,55.202  56.707,52.767 60.442,54.917 66.472,50.9 71.642,48.888 73.225,45.3 77.673,41.277 80.4,35.966 79.685,30.226 81.404,30.226  94.04,36.683 96.77,42.714 97.058,46.014 100.497,47.741 100.497,50.9 103.228,53.482 112.704,52.767 117.155,61.376  117.155,65.257 112.99,71.287 116.008,81.765 122.899,83.493 129.639,79.898 130.654,77.746 140.125,72.721 145.583,76.025  142.568,81.336 148.307,89.665 155.772,92.82 156.209,97.852 200,98.852 188.801,132.162 191.092,139.338 191.092,146.808  177.598,142.497 165.251,141.782 171.426,136.467 170.423,134.602 166.975,134.309 162.237,138.619 159.223,131.155  152.041,136.754 151.324,139.624 153.479,142.207 138.55,148.958 137.83,151.829 103.228,167.62 90.883,169.774 75.66,166.187  66.472,160.734 36.612,156.137 22.398,146.517 2.014,139.624 "
});

var Svg20 = function Svg20(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OAX",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg20, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/20.4cb80a7d.svg";
export { ForwardRef as ReactComponent };